import parser from 'ua-parser-js';
import DateString from '$shared/models/DateString';
import type { IAuthToken } from '$shared/interfaces/api/IAuthToken';

export default class AuthToken {
  readonly id: string;
  readonly isCurrent: boolean;
  readonly lastIpAddress: string;
  readonly lastUsed: DateString;
  readonly lastUserAgent: string;
  readonly expiresAt: DateString;

  constructor(
    id: string,
    isCurrent: boolean,
    lastIpAddress: string,
    lastUsed: DateString,
    lastUserAgent: string,
    expiresAt: string
  ) {
    this.id = id;
    this.isCurrent = isCurrent;
    this.lastIpAddress = lastIpAddress;
    this.lastUsed = lastUsed;
    this.lastUserAgent = lastUserAgent;
    if (expiresAt) {
      this.expiresAt = new DateString(expiresAt);
    }
  }

  static fromResponse(authToken: IAuthToken): AuthToken {
    return new AuthToken(
      authToken.id,
      authToken.isCurrent,
      authToken.lastIpAddress,
      new DateString(authToken.lastUsed),
      authToken.lastUserAgent,
      authToken?.expiresAt
    );
  }

  get lastActive(): string {
    return this.lastUsed.getLocalizedDateAndTime();
  }

  get device(): string {
    const ua = parser(this.lastUserAgent);
    return `${ua.os.name} | ${ua.browser.name} ${ua.browser.version}`;
  }

  get currentDevice(): string {
    return this.isCurrent ? 'Yes' : 'No';
  }
}
